import { ExternalLink } from 'lucide-react'
import React from 'react'

import type { AdminMedicalPlanListItem } from 'utils/web_api.schemas'

export const ExpandedMedicalPlanRow: React.FC<{ plan: AdminMedicalPlanListItem }> = ({ plan }) => {
  return (
    <div className='p-6 bg-gray-50 border-l-4 border-blue-400'>
      <div className='flex items-center justify-between mb-4'>
        <h4 className='font-semibold text-gray-900'>Plan Details</h4>
        <a
          href={`/admin/inspect/${plan.id}`}
          className='text-blue-600 hover:text-blue-800 hover:underline text-sm font-medium flex items-center gap-1'
        >
          <ExternalLink className='w-4 h-4' />
          View Full Details
        </a>
      </div>

      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm'>
        {/* HIOS ID */}
        <div>
          <span className='font-medium text-gray-700'>HIOS ID:</span>
          <div className='mt-1 text-gray-600'>{plan.hios_id || 'N/A'}</div>
        </div>

        {/* Plan Year */}
        <div>
          <span className='font-medium text-gray-700'>Plan Year:</span>
          <div className='mt-1 text-gray-600'>{plan.year || 'N/A'}</div>
        </div>

        {/* Metal Tier */}
        <div>
          <span className='font-medium text-gray-700'>Metal Tier:</span>
          <div className='mt-1 text-gray-600'>
            {plan.metal_tier
              ? plan.metal_tier.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
              : 'N/A'}
          </div>
        </div>

        {/* Individual Medical Deductible */}
        <div>
          <span className='font-medium text-gray-700'>Individual Medical Deductible:</span>
          <div className='mt-1 text-gray-600'>{plan.individual_deductible || 'N/A'}</div>
        </div>

        {/* Individual Medical MOOP */}
        <div>
          <span className='font-medium text-gray-700'>Individual Medical MOOP:</span>
          <div className='mt-1 text-gray-600'>{plan.individual_moop || 'N/A'}</div>
        </div>

        {/* Primary Care Physician Benefit */}
        <div>
          <span className='font-medium text-gray-700'>Primary Care Physician Benefit:</span>
          <div className='mt-1 text-gray-600'>{plan.primary_care_physician_benefit || 'N/A'}</div>
        </div>

        {/* Plan Coinsurance */}
        <div>
          <span className='font-medium text-gray-700'>Plan Coinsurance:</span>
          <div className='mt-1 text-gray-600'>{plan.plan_coinsurance || 'N/A'}</div>
        </div>

        {/* Preferred Brand Drugs Benefit */}
        <div>
          <span className='font-medium text-gray-700'>Preferred Brand Drugs Benefit:</span>
          <div className='mt-1 text-gray-600'>{plan.preferred_brand_drugs_benefit || 'N/A'}</div>
        </div>

        {/* Specialist Benefit */}
        <div>
          <span className='font-medium text-gray-700'>Specialist Benefit:</span>
          <div className='mt-1 text-gray-600'>{plan.specialist_benefit || 'N/A'}</div>
        </div>

        {/* Generic Drugs Benefit */}
        <div>
          <span className='font-medium text-gray-700'>Generic Drugs Benefit:</span>
          <div className='mt-1 text-gray-600'>{plan.generic_drugs_benefit || 'N/A'}</div>
        </div>

        {/* SBC URL */}
        <div>
          <span className='font-medium text-gray-700'>Summary of Benefits and Coverage:</span>
          {plan.sbc_url
            ? (
              <div className='mt-1'>
                <a
                  href={plan.sbc_url}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-600 hover:text-blue-800 underline'
                >
                  View SBC
                </a>
              </div>
              )
            : (
              <div className='mt-1 text-gray-600'>Unavailable</div>
              )}
        </div>
      </div>
    </div>
  )
}
